const localConstants = {
  googleClientId:
    "717550879730-3mt99b4v7e6gecfmvf7c440junqr9ulp.apps.googleusercontent.com",
  microsoftClientId: "e8e6f983-6869-4d46-bf59-7357a7885673",
  microsoftRedirectUrl: "http://localhost:3000",
  backendServer: "https://s0oms8vh2b.execute-api.us-east-1.amazonaws.com/Prod/",
  stepFunctionServer:
    "https://wzr9ig00gf.execute-api.us-east-1.amazonaws.com/signupExecutionInLastStepApi",
};

const qaConstants = {
  googleClientId:
    "717550879730-3mt99b4v7e6gecfmvf7c440junqr9ulp.apps.googleusercontent.com",
  microsoftClientId: "3af6741d-2cd8-4943-96b6-c0f14a14f54e",
  microsoftRedirectUrl: "https://qa-onboarding.voltuswave.com",
  backendServer: "https://wko3htep18.execute-api.us-east-1.amazonaws.com/Prod/",
  stepFunctionServer:
    "https://fc35fqrbsl.execute-api.us-east-1.amazonaws.com/signupExecutionInLastStepApi", // step function gateway api
};

const prodConstants = {
  googleClientId:
    "717550879730-3mt99b4v7e6gecfmvf7c440junqr9ulp.apps.googleusercontent.com",
  microsoftClientId: "f6d07835-6a25-4ef3-9949-ba41cc2ff630",
  microsoftRedirectUrl: "https://onboarding.voltuswave.com/",
  backendServer: "https://qjcwe10bo9.execute-api.us-east-1.amazonaws.com/Prod/",
  stepFunctionServer:"https://einjkgr8hg.execute-api.us-east-1.amazonaws.com/signupExecutionInLastStepApi"
};

// export const buildConstants = localConstants;
export const buildConstants = qaConstants;
// export const buildConstants = prodConstants;

//for local :- localConstants
//for qa :- qaConstants
//for prod :- prodConstants
